import { createSlice } from '@reduxjs/toolkit';

import {
  UserClearWishList,
  UserGetSingleWishList,
  UserGetWishList,
  UserMajorWishListCreation,
  UserRemoveWishList,
  UserWishListCreation,
} from './wish_list_services_sync';

export const userWishListSlice = createSlice({
  name: 'user_wish_list',
  initialState: {
    wish_list_loader: false,
    wish_list_all_loader: false,
    clear_wish_list_loader: false,
    message: '',
    wish_list: {},
    wishListDetails: {},
    wishListIndicator: '',
    wishListRemoveIndicator: '',
  },
  reducers: {
    clearState: (state) => {
      state.wish_list_loader = false;
      state.wish_list_all_loader = false;
      state.clear_wish_list_loader = false;
      state.message = '';
      state.wish_list = {};
      state.wishListDetails = {};
      state.wishListIndicator = '';
      state.wishListRemoveIndicator = '';

      return state;
    },

    updateWishListIndicator: (state, { payload }) => {
      state.wishListIndicator = payload;
    },

    updateWishListRemoveIndicator: (state, { payload }) => {
      state.wishListRemoveIndicator = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(UserWishListCreation.pending, (state) => {
        state.wish_list_loader = true;
      })
      .addCase(UserWishListCreation.fulfilled, (state, { payload }) => {
        state.wishListDetails = payload?.data?.products[payload?.cartIndex];

        state.wish_list_loader = false;
        state.message = payload?.message;
      })
      .addCase(UserWishListCreation.rejected, (state, { payload }) => {
        state.wish_list_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(UserMajorWishListCreation.pending, (state) => {
        state.wish_list_loader = true;
      })
      .addCase(UserMajorWishListCreation.fulfilled, (state, { payload }) => {
        state.wish_list = payload?.data;

        state.wish_list_loader = false;
        state.message = payload?.message;

        state.wishListIndicator = '';
      })
      .addCase(UserMajorWishListCreation.rejected, (state, { payload }) => {
        state.wish_list_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(UserGetWishList.pending, (state) => {
        state.wish_list_all_loader = true;
      })
      .addCase(UserGetWishList.fulfilled, (state, { payload }) => {
        state.wish_list_all_loader = false;
        state.message = payload?.message;
        state.wish_list = payload?.data;
      })
      .addCase(UserGetWishList.rejected, (state, { payload }) => {
        state.wish_list_all_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(UserGetSingleWishList.pending, (state) => {
        state.wish_list_loader = true;
      })
      .addCase(UserGetSingleWishList.fulfilled, (state, { payload }) => {
        state.wish_list_loader = false;
        state.message = payload?.message;
        state.wishListDetails = payload?.data;
      })
      .addCase(UserGetSingleWishList.rejected, (state, { payload }) => {
        state.wish_list_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(UserClearWishList.pending, (state) => {
        state.clear_wish_list_loader = true;
      })
      .addCase(UserClearWishList.fulfilled, (state, { payload }) => {
        state.clear_wish_list_loader = false;
        state.message = payload?.message;

        state.wish_list = null;
      })
      .addCase(UserClearWishList.rejected, (state, { payload }) => {
        state.clear_wish_list_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(UserRemoveWishList.pending, (state) => {
        state.wish_list_loader = true;
      })
      .addCase(UserRemoveWishList.fulfilled, (state, { payload }) => {
        state.wish_list = payload?.data;

        state.wish_list_loader = false;
        state.message = payload?.message;

        state.wishListRemoveIndicator = '';
      })
      .addCase(UserRemoveWishList.rejected, (state, { payload }) => {
        state.wish_list_loader = false;
        state.message = payload?.message;
      });
  },
});

export const {
  clearState,
  updateWishListIndicator,
  updateWishListRemoveIndicator,
} = userWishListSlice.actions;
export const wishlistSelector = (state) => state.user_wish_list;

export default userWishListSlice.reducer;
